export default {
  strict: true,
  namespaced: true,
  state: {
    show: false,
    profile: {
      loading: false,
      info: {
        id: '',
        consId: '',
        logo: '',
        username: '',
        password: '',
        name: '',
        email: '',
        color: '#000000',
        countryCode: 1,
        mobile: '',
        website: '',
        cardOwner: '',
        creditCard: '',
        cardExpiration: '',
        cardCVV: '',
        billingAddress1: '',
        billingAddress2: '',
        billingCity: '',
        billingState: '',
        billingZip: '',
        billingCountry: 'us',
        stripeUrl: '',
        active: false
      },
      creditCard: {
        owner: '',
        card: '',
        expiration: '',
        cvv: ''
      }
    }
  },
  mutations: {
    showModal (state) { state.show = true },
    hideModal (state) { state.show = false },
    setSignupLoading (state, value) { state.profile.loading = value },
    setProfileInfo (state, data) { state.profile.info[data.field] = data.value }
  }
}



// WEBPACK FOOTER //
// ./src/store/login-signup/index.js